import { ref } from 'vue'

import { defineStore } from 'pinia'

/**
 * Invitations UI Store — handles all invitation-related UI state
 * All data fetching and API calls are handled by the useInvitations composable
 */
export const useInvitationsStore = defineStore('invitations', () => {
  // ===== STATE =====
  const showInvitationModal = ref(false)
  const invitationLink = ref('')
  const gokollabInvitationLink = ref('')
  const forbiddenInvitation = ref(false)
  const isGeneratingLink = ref(false)

  // ===== ACTIONS =====
  const setShowInvitationModal = (show: boolean) => {
    showInvitationModal.value = show
  }

  const setInvitationLink = (link: string) => {
    invitationLink.value = link
  }

  const setGokollabInvitationLink = (link: string) => {
    gokollabInvitationLink.value = link
  }

  const setForbiddenInvitation = (forbidden: boolean) => {
    forbiddenInvitation.value = forbidden
  }

  const setIsGeneratingLink = (loading: boolean) => {
    isGeneratingLink.value = loading
  }

  const resetInvitationState = () => {
    invitationLink.value = ''
    gokollabInvitationLink.value = ''
    forbiddenInvitation.value = false
    isGeneratingLink.value = false
  }

  // ===== PUBLIC API =====
  return {
    // State
    showInvitationModal,
    invitationLink,
    gokollabInvitationLink,
    forbiddenInvitation,
    isGeneratingLink,

    // Actions
    setShowInvitationModal,
    setInvitationLink,
    setGokollabInvitationLink,
    setForbiddenInvitation,
    setIsGeneratingLink,
    resetInvitationState,
  }
})
